import { toast } from 'react-toastify';

import { uniqueId } from 'lodash';
import api from '../../api';
import { User } from '../usuarios';
import {
  ChangePassword,
  ForgotPasswordProps,
  SignInCredentials,
  SignUpCredentials,
  Tokens,
} from './types';

export function getDataInLocalStorage(key: string) {
  const dataString = localStorage.getItem(key!);

  if (!dataString || dataString === undefined) {
    return '';
  }

  if (typeof dataString === 'string') {
    const json = dataString === undefined ? '' : JSON.parse(dataString);

    return json;
  }
  return '';
}

export function setUserLocalStorage(user: User | null) {
  localStorage.setItem('@governanca:u', JSON.stringify(user ?? null));
}

export function setTokensLocalStorage(tokens: Tokens | null) {
  const tokensEmpty = {
    access_token: '',
    refresh_token: '',
  };
  localStorage.setItem('@governanca:t', JSON.stringify(tokens ?? tokensEmpty));
}

export function setRemoveAuthentication() {
  const useAuthStore = {
    state: {
      tokens: null,
      signed: false,
      menuSelected: 'portal',
      user: null,
    },
  };

  localStorage.setItem('useAuthStore', JSON.stringify(useAuthStore));
  setTokensLocalStorage({ access_token: '', refresh_token: '' });
  window.history.replaceState({}, '', '/');
}

export function getUserLocalStorage(): User | string {
  const user = getDataInLocalStorage('@governanca:u');

  return user;
}

export function getTokensLocalStorage(): Tokens | string {
  const tokens = getDataInLocalStorage('@governanca:t');

  return tokens;
}

export function clearUserLocalStorage() {
  const teste = localStorage.removeItem('@governanca:u');
  return teste;
}

export function clearTokensLocalStorage() {
  const teste = localStorage.removeItem('@governanca:t');
  return teste;
}

export async function signUpRequest({
  email,
  name,
  profile,
  phone,
  companies_ids,
  companies,
  doc,
  userId,
}: SignUpCredentials) {
  try {
    const response = await api().post(
      '/auth/sign-up',
      {
        name,
        email,
        profile,
        phone,
        companies_ids,
        companies,
        doc,
      },
      {
        headers: {
          userId,
        },
      },
    );

    return response;
  } catch (error: any) {
    if (error.response.status === 500) {
      toast.error('Erro desconhecido, contate o suporte', {
        toastId: uniqueId(),
      });
    } else {
      toast.error(error.response.data.message, {
        toastId: uniqueId(),
      });
    }
    return null;
  }
}

export async function signInRequest({
  email,
  password,
  token,
}: SignInCredentials) {
  const response = await api().post('/auth/sign-in', {
    email,
    password,
    token,
  });
  return response;
}

export async function fastLoginRequest({
  email,
  password,
  token,
}: SignInCredentials) {
  try {
    const response = await api().post('/auth/fast-login', {
      email,
      password,
      token,
    });

    return response;
  } catch (error: any) {
    if (error.response.status === 500) {
      toast.error('Erro desconhecido, contate o suporte', {
        toastId: uniqueId(),
      });
    } else {
      toast.error(error.response.data.message, {
        toastId: uniqueId(),
      });
    }
    return null;
  }
}

export async function signOutRequest() {
  // clearUserLocalStorage();
  // clearTokensLocalStorage();

  // setTokensLocalStorage(null);
  // setUserLocalStorage(null);

  await api().post('/auth/sign-out');
}

export async function changePasswordRequest(password: string, token: string) {
  try {
    const response = await api().post(`/auth/change-password/${token}`, {
      password,
    });

    return response;
  } catch (error: any) {
    if (error.response.status === 500) {
      toast.error('Erro desconhecido, contate o suporte', {
        toastId: uniqueId(),
      });
    } else {
      toast.error(error.response.data.message, {
        toastId: uniqueId(),
      });
    }
    return null;
  }
}

export async function updatePasswordRequest({
  old_password,
  password,
  email,
}: ChangePassword) {
  try {
    const response = await api().post(`/auth/update-password`, {
      old_password,
      password,
      email,
    });

    return response;
  } catch (error: any) {
    if (error.response.status === 500) {
      toast.error('Erro desconhecido, contate o suporte', {
        toastId: uniqueId(),
      });
    } else {
      toast.error(error.response.data.message, {
        toastId: uniqueId(),
      });
    }
    return null;
  }
}

export async function forgotPasswordRequest({
  email,
  token,
}: ForgotPasswordProps) {
  try {
    const response = await api().post(`/auth/forgot-password`, {
      email,
      token,
    });

    return response;
  } catch (error: any) {
    if (error.response.status === 500) {
      toast.error('Erro desconhecido, contate o suporte', {
        toastId: uniqueId(),
      });
    } else {
      toast.error(error.response.data.message, {
        toastId: uniqueId(),
      });
    }
    return null;
  }
}

export async function refreshTokenRequest() {
  const user = getUserLocalStorage() as User;
  const tokens = getTokensLocalStorage() as Tokens;

  try {
    const data = {
      email: user.email,
    };

    const response = await api().post('/auth/refresh', data, {
      headers: {
        Authorization: tokens.refresh_token,
      },
    });

    return response;
  } catch (error: any) {
    if (error.response.status === 500) {
      toast.error('Erro desconhecido, contate o suporte', {
        toastId: uniqueId(),
      });
    } else {
      toast.error(error.response.data.message, {
        toastId: uniqueId(),
      });
    }
    return null;
  }
}

export async function validateCode(email: string, code: string) {
  const data = {
    code,
  };
  try {
    const response = await api().post('auth/code', data, {
      headers: {
        email,
      },
    });

    return response;
  } catch (err: any) {
    console.log(err);
    if (err.response.status === 500) {
      toast.error('Erro desconhecido, contate o suporte', {
        toastId: uniqueId(),
      });
    } else {
      toast.error(err.response.data.message, {
        toastId: uniqueId(),
      });
    }
    return null;
  }
}

export async function resendCode(email: string) {
  try {
    const response = await api().post(
      'auth/resend-code',
      {},
      { headers: { email } },
    );

    return response;
  } catch (err: any) {
    console.log(err);
    if (err.response.status === 500) {
      toast.error('Erro desconhecido, contate o suporte', {
        toastId: uniqueId(),
      });
    } else {
      toast.error(err.response.data.message, {
        toastId: uniqueId(),
      });
    }
    return null;
  }
}

export async function resendInviteRequest(id: string, companyId: string) {
  try {
    const response = api().post(
      `/auth/resend-invite/${id}`,
      {},
      {
        headers: {
          companyId,
        },
      },
    );

    return response;
  } catch (error: any) {
    console.log(error);
    if (error.response.status === 500) {
      toast.error('Erro desconhecido, contate o suporte', {
        toastId: uniqueId(),
      });
    } else {
      toast.error(error.response.data.message, {
        toastId: uniqueId(),
      });
    }
    return null;
  }
}

export async function getUserInviteByUserIdRequest(
  id: string,
  accountId: string,
) {
  try {
    const response = api().get(`/auth/get-invite/${id}`, {
      headers: {
        accountId,
      },
    });
    return response;
  } catch (error: any) {
    console.log(error);
    if (error.response.status === 500) {
      toast.error('Erro desconhecido, contate o suporte');
    } else if (error.response.status === 401) {
      console.error('Não autorizado');
      return null;
    } else {
      toast.error(error.response.data.message);
    }
    return null;
  }
}
